import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Anchor, CalendarDays, CircleDollarSign, MessageCircleMore, MessagesSquareIcon, Ship, ShipWheel, Users, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CotaNauticaModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const benefits = [
    {
        icon: Users,
        title: 'Acesso inteligente',
        description: 'Você não precisa investir 100% do valor da embarcação para aproveitar.',
    },
    {
        icon: CircleDollarSign,
        title: 'Custo reduzido',
        description: 'Investimento, manutenção, marina e despesas divididos entre os cotistas.',
    },
    {
        icon: CalendarDays,
        title: 'Uso planejado',
        description: 'Agenda organizada entre os cotistas, garantindo previsibilidade e conforto.',
    },
    {
        icon: Ship,
        title: 'Experiência completa',
        description: 'Você utiliza embarcações de alto padrão por uma fração do custo.',
    },
];

export const CotaNauticaModal: React.FC<CotaNauticaModalProps> = ({ isOpen, onClose }) => {
    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="max-w-md rounded-2xl overflow-hidden p-4">
                <DialogHeader className="relative">

                    <DialogTitle className="flex gap-4 items-center text-2xl font-semibold">
                        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-green-200/40">
                            <Anchor className="h-8 w-8 text-green-600" />
                        </div>
                        O que é Cota Náutica?
                    </DialogTitle>


                    <p className="text-md leading-6 text-muted-foreground">
                        Cota Náutica é a compra compartilhada de uma embarcação. Você adquire uma fração do barco e divide o uso, os custos e a manutenção com outros proprietários.
                    </p>
                </DialogHeader>

                <hr />

                <div className="space-y-4">
                    {benefits.map((item) => {
                        const Icon = item.icon;

                        return (
                            <div key={item.title} className="flex items-center gap-4">
                                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-green-200/30">
                                    <Icon className="h-8 w-8 text-green-600" />
                                </div>

                                <div className="min-w-0">
                                    <h4 className="text-md font-semibold text-foreground">
                                        {item.title}
                                    </h4>
                                    <p className="text-md leading-5 text-muted-foreground">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        );
                    })}

                    <div className="flex items-center gap-4 rounded-xl bg-green-100/40 p-2">
                        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-green-200/30">
                            <MessagesSquareIcon className="h-8 w-8 text-green-600" />
                        </div>

                        <div>
                            <h4 className="text-md font-semibold text-foreground">
                                Quer saber mais?
                            </h4>
                            <p className="text-md leading-5 text-muted-foreground">
                                Fale com um especialista e descubra as opções de Cota Náutica disponíveis.
                            </p>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};